export const MAXIMUM_GENERATION_PER_USER = 10;
